import axios from "axios";
export default {
  async GET_LIST({
    commit
  }, payload) {
    const {
      data
    } = await axios.get("recipe", {
      params: payload ? payload.search : {}
    });
    commit("SET_LIST", data);
  },
  async DELETE({
    commit
  }, payload) {
    const {
      data
    } = await axios.delete(`recipe/${payload.id}`);
    if (data.ok) {
      commit("REMOVE_RECORD", payload.index);
    }
  },
  async CREATE_NEW({
    commit
  }, payload) {
    const {
      data
    } = await axios.post("recipe", payload);
    if (data.ok) {
      commit("ADD_NEW", data.data);
    }
  },
  async UPDATE({
    commit
  }, payload) {
    const {
      data
    } = await axios.put(`recipe/${payload.id}`, payload);
    if (data.ok) {
      commit("UPDATE", {
        recipe: data.data,
        index: payload.index
      });
    }
  }
};
